import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import BalanceReducer from "./balanceReducer";
import { profileDetailsReducer } from "./profileDetailsReducer";
import { fullScreenLoadingReducer } from "./fullScreenLoadingReducer";
import { currentTabReducer } from "./currentTabReducer";
import { addAccountsReducer } from "./add_customer/addAccountReducer";
import { scheduleJobReducer } from "./scheduleJobReducer";
const rootReducer = combineReducers({
  AuthReducer,
  BalanceReducer,
  profileDetailsReducer,
  fullScreenLoadingReducer,
  addAccountsReducer,
  currentTabReducer,
  scheduleJobReducer,
});

export default rootReducer;
